import { auditReportSchema } from '@repo/shared';
import type { AuditDependency, AuditReport } from '@repo/shared';
import { apiRequest } from '../../lib/api';

/**
 * POST /api/v1/audit — send pre-parsed dependencies, get back a verdict for each
 * one. Manifest parsing happens client-side before this call; a dependency the
 * manifest gave as a range arrives with `version: null` and is resolved to its
 * upper bound by the Worker.
 */
export function runAudit(dependencies: AuditDependency[]): Promise<AuditReport> {
  return apiRequest('/v1/audit', auditReportSchema, {
    method: 'POST',
    body: { dependencies },
  });
}
